import type { VariantProps } from "class-variance-authority"
import { cva } from "class-variance-authority"

export { default as Button } from "./Button.vue"

export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium cursor-pointer transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        // `default` (primary, Counsel Black) = commit-action ("this happens now");
        // `accent` (Action Signal) = navigate/go-here — a FILL with `ink` on top, never
        // white. See DESIGN.md "Card-on-tint" and "Action Signal is a fill, not an ink".
        default: "bg-primary text-primary-foreground hover:bg-primary/90",
        accent: "bg-accent text-accent-foreground hover:bg-accent/90",
        destructive:
          "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline:
          "border border-input bg-background hover:bg-accent-lighter hover:text-accent-lighter-foreground",
        secondary:
          "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        // For buttons drawn ON THE INK SLAB (the marketing hero, navbar and footer) rather
        // than on the sheet. The slab is the same value in BOTH themes, so it needs `ink-*`
        // tokens: `outline`/`ghost`/`secondary` are sheet tokens that invert with the theme,
        // and on the ink they read as a white slab in light mode and all but vanish in dark.
        // (Not `sidebar-*`: since MAR-1316 the app frame is gray and themes.)
        frame:
          "border border-ink-border bg-transparent text-ink-foreground hover:bg-ink-hover",
        ghost: "hover:bg-accent-lighter hover:text-accent-lighter-foreground",
        link: "text-primary underline-offset-4 hover:underline",
      },
      // Radius is uniform (base rounded-md, the "control" convention); sizes
      // vary height/padding only.
      size: {
        "default": "h-9 px-4 py-2",
        "xs": "h-7 px-2",
        "sm": "h-8 px-3 text-xs",
        "lg": "h-10 px-8",
        "icon": "h-9 w-9",
        "icon-sm": "size-8",
        "icon-lg": "size-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
)

export type ButtonVariants = VariantProps<typeof buttonVariants>
